import {
  Alert,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Switch,
  Typography,
  Upload,
  message,
  Tooltip,
} from "antd";
import axios from "axios";
import { InboxOutlined, InfoCircleOutlined, SendOutlined } from "@ant-design/icons";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAllDesignation } from "../../redux/rtk/features/designation/designationSlice";
import { toast } from "react-toastify";
import { getRoles } from "../role/roleApis";

import { getDepartments } from "../department/departmentApis";
import { loadAllEmploymentStatus } from "../../redux/rtk/features/employemntStatus/employmentStatusSlice";
import { loadAllShift } from "../../redux/rtk/features/shift/shiftSlice";

import { loadAllWeeklyHoliday } from "../../redux/rtk/features/weeklyHoliday/weeklyHolidaySlice";
import { loadAllLeavePolicy } from "../../redux/rtk/features/leavePolicy/leavePolicySlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import { createStripeInvite } from "../stripe/stripeApis";

const AddUser = () => {
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const { Title } = Typography;
  const { Option } = Select;
  const [list, setList] = useState(null);
  const [department, setDepartment] = useState(null);
  const { Dragger } = Upload;
  const [selectedRoleId, setSelectedRoleId] = useState(null);

  const [inviteLoading, setInviteLoading] = useState(false);
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const [inviteLink, setInviteLink] = useState("");

  const employmentStatus = useSelector((state) => state.employmentStatus?.list);

  useEffect(() => {
    getRoles()
      .then((d) => setList(d))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    getDepartments()
      .then((d) => setDepartment(d))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    dispatch(loadAllDesignation());
    dispatch(loadAllEmploymentStatus());
    dispatch(loadAllShift());
    dispatch(loadAllWeeklyHoliday());
    dispatch(loadAllLeavePolicy());
  }, []);

  const [form] = Form.useForm();

  const handleSendInvite = async () => {
    const email = form.getFieldValue("email");
    if (!email) {
      toast.error("Please enter the user's email first");
      return;
    }
    try {
      setInviteLoading(true);
      const result = await createStripeInvite(email);
      form.setFieldsValue({ stripeAccountId: result.accountId });
      setInviteLink(result.onboardingUrl);
      setInviteModalOpen(true);
      toast.success("Stripe account created — copy the invite link below");
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to create invite link"
      );
    } finally {
      setInviteLoading(false);
    }
  };

  const onFinish = async (values) => {
    try {
      setLoader(true);

      const formData = new FormData();

      // Append all basic fields
      formData.append("firstName", values.firstName);
      formData.append("lastName", values.lastName);
      formData.append("userName", values.userName);
      formData.append("password", values.password);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      formData.append("street", values.street);
      formData.append("city", values.city);
      formData.append("country", values.country);
      formData.append("roleId", values.roleId);
      formData.append("rating", values.rating || "");

      // Append hourly rate (if role is ServiceMan)
      if (values.hourlyRate) {
        formData.append("hourlyRate", values.hourlyRate);
      }
      if (values.stripeAccountId) {
        formData.append("stripeAccountId", values.stripeAccountId);
      }

      // Append image file
      if (values.image && values.image[0]?.originFileObj) {
        formData.append("image", values.image[0].originFileObj);
      }

      // Append employment statuses (if multiple, send as repeated keys)
      if (values.employmentStatusId && values.employmentStatusId.length > 0) {
        values.employmentStatusId.forEach((id) => {
          formData.append("employmentStatusId", id);
        });
      }

      // Append education array (optional enhancement, if backend supports)
      if (values.educations && Array.isArray(values.educations)) {
        formData.append("educations", JSON.stringify(values.educations));
      }

      const resp = await axios.post("/user/register", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (resp.data) {
        form.resetFields();
        toast.success("User added successfully!");
      }
      setLoader(false);
    } catch (error) {
      console.error("Register Error:", error);
      toast.error("Failed to add user.");
      setLoader(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoader(false);
    console.log("Failed:", errorInfo);
  };

  return (
    <Fragment>
      <UserPrivateComponent permission={"create-user"}>
        <div className="mr-top mt-5 p-5 ant-card " style={{ maxWidth: "100%" }}>
          <Form
            size="small"
            form={form}
            name="basic"
            labelCol={{
              span: 7,
            }}
            wrapperCol={{
              span: 22,
            }}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Row justify="center" gutter={[16, 16]}>
              <Col
                span={24}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "24px",
                }}
              >
                <Form.Item
                  name="roleId"
                  label="Role"
                  required
                  rules={[
                    {
                      required: true,
                      message: "Please select a role",
                    },
                  ]}
                  labelCol={{
                    style: {
                      fontWeight: 500,
                      fontSize: "16px",
                    },
                  }}
                  colon={false}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 0,
                  }}
                >
                  <Select
                    loading={!list}
                    size="middle"
                    allowClear
                    placeholder="Select Role"
                    style={{ minWidth: "200px" }}
                    onChange={(value) => setSelectedRoleId(value)}
                  >
                    {list
                      ?.filter((role) => role.name.toLowerCase() !== "admin")
                      .map((role) => (
                        <Option key={role.id} value={role.id}>
                          {role.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              {/* User Information Column */}
              <Col xs={24} md={12}>
                <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                  User Information
                </h2>
                <Form.Item
                  label="Upload Image"
                  name="image"
                  rules={[
                    {
                      required: true,
                      message: "Please upload your image",
                    },
                  ]}
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) return e;
                    return e?.fileList;
                  }}
                >
                  <Dragger
                    name="file"
                    multiple={false}
                    accept="image/*"
                    beforeUpload={() => false}
                    maxCount={1}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                      Click or drag image to upload
                    </p>
                  </Dragger>
                </Form.Item>
                <Form.Item
                  label="First Name"
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: "Please input First Name!",
                    },
                  ]}
                >
                  <Input placeholder="John" />
                </Form.Item>
                <Form.Item
                  label="Last Name"
                  name="lastName"
                  rules={[
                    {
                      required: true,
                      message: "Please input Last Name!",
                    },
                  ]}
                >
                  <Input placeholder="Doe" />
                </Form.Item>
                <Form.Item
                  label="User Name"
                  name="userName"
                  rules={[
                    {
                      required: true,
                      message: "Please input User Name!",
                    },
                  ]}
                >
                  <Input placeholder="john_doe" />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                >
                  <Input placeholder="Strong Password" />
                </Form.Item>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input email!",
                    },
                  ]}
                >
                  <Input placeholder="johndoe@example.com" />
                </Form.Item>

                <Form.Item
                  label="Phone"
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: "Please input phone number",
                    },
                    {
                      pattern: /^\d+$/,
                      message: "Only digits are allowed",
                    },
                  ]}
                >
                  <Input placeholder="Enter phone number" />
                </Form.Item>

                {selectedRoleId === 3 && (
                  <Form.Item
                    name="employmentStatusId"
                    label={
                      <span>
                        Categories&nbsp;
                        <Tooltip title="You can select multiple categories">
                          <InfoCircleOutlined />
                        </Tooltip>
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                        message: "Please Selct Category!",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Status"
                      allowClear
                      size="middle"
                      mode="multiple"
                    >
                      {employmentStatus &&
                        employmentStatus.map((status) => (
                          <Option key={status.id} value={status.id}>
                            {status.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                )}

                {selectedRoleId === 3 && (
                  <Form.Item
                    name="hourlyRate"
                    label="Hourly Rate (€)"
                    rules={[
                      {
                        required: true,
                        message: "Please enter hourly rate",
                      },
                    ]}
                  >
                    <Input placeholder="20" />
                  </Form.Item>
                )}

                {selectedRoleId === 3 && (
                  <>
                    <Form.Item
                      name="stripeAccountId"
                      label="Stripe Account Id"
                      tooltip="Optional — click 'Send Invite Link' to auto-generate one, or paste an existing account id"
                    >
                      <Input placeholder="Auto-filled after sending an invite, or paste manually" />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 7, span: 15 }} style={{ marginTop: -12 }}>
                      <Button
                        icon={<SendOutlined />}
                        loading={inviteLoading}
                        onClick={handleSendInvite}
                      >
                        Send Invite Link
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Col>

              {/* Address Information Column */}
              <Col xs={24} md={12}>
                <h2 className="text-center text-xl mt-3 mb-3 txt-color">
                  Address Information
                </h2>
                <Form.Item
                  label="Country"
                  name="country"
                  rules={[
                    {
                      required: true,
                      message: "Please input Country!",
                    },
                  ]}
                >
                  <Input placeholder="USA" />
                </Form.Item>
                <Form.Item
                  label="City"
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "Please input city!",
                    },
                  ]}
                >
                  <Input placeholder="Los Angeles" />
                </Form.Item>
                <Form.Item
                  label="Address"
                  name="street"
                  rules={[
                    {
                      required: true,
                      message: "Please input street!",
                    },
                  ]}
                >
                  <Input placeholder="123 Main Street" />
                </Form.Item>

                {/* <Form.Item
                                    label="State"
                                    name="state"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input state!",
                                        },
                                    ]}
                                >
                                    <Input placeholder="CA" />
                                </Form.Item> */}
                {/* <Form.Item
                                    label="Zip Code"
                                    name="zipCode"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please input Zip Code!",
                                        },
                                    ]}
                                >
                                    <Input placeholder="90211" />
                                </Form.Item> */}
              </Col>
            </Row>

            <Form.Item
              style={{ marginBottom: "10px", marginTop: "10px" }}
              wrapperCol={{
                offset: 4,
                span: 16,
              }}
            >
              <Button
                className="mt-5"
                size="large"
                onClick={() => setLoader(true)}
                block
                type="primary"
                htmlType="submit"
                shape="round"
                loading={loader}
              >
                Add New User
              </Button>
            </Form.Item>
          </Form>
        </div>

        <Modal
          title="Stripe Onboarding Invite Link"
          open={inviteModalOpen}
          onCancel={() => setInviteModalOpen(false)}
          footer={[
            <Button key="close" onClick={() => setInviteModalOpen(false)}>
              Close
            </Button>,
          ]}
        >
          <p>
            The Stripe account id has been filled in automatically. Share this
            link with the new service man so they can complete their payout
            setup:
          </p>
          <Typography.Paragraph
            copyable={{ text: inviteLink }}
            style={{
              background: "#fafafa",
              border: "1px solid #f0f0f0",
              borderRadius: 6,
              padding: "8px 12px",
              wordBreak: "break-all",
              marginBottom: 0,
            }}
          >
            {inviteLink}
          </Typography.Paragraph>
        </Modal>
      </UserPrivateComponent>
    </Fragment>
  );
};

export default AddUser;
